import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';
import AnimatedSection from '../ui/AnimatedSection';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "Ramwin Technology's IT solutions is a game-changer for our business. Their expertise in software development and security has helped us streamline our operations.",
      author: "Client",
      role: "Business Owner",
      company: "Enterprise Client"
    },
    {
      quote: "Companies often overlook user experience when trying to give their employees access to the secure systems they need. Ramwin helped us achieve that with their solutions.",
      author: "Client",
      role: "IT Manager",
      company: "Technology Firm"
    },
    {
      quote: "The methodology provides a clear and comprehensive explanation of the approach. The team demonstrates a thorough understanding of the techniques used.",
      author: "Reviewing Team",
      role: "Quality Assurance",
      company: "Industry Expert"
    }
  ];

  return (
    <section id="testimonials" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Ramwin Trusted by Innovators</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Join the forward-thinking companies leveraging our IT solutions to drive growth and innovation.
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {testimonials.map((testimonial, index) => (
            <AnimatedSection key={index} delay={index * 0.1}>
              <div className="dark-card rounded-xl transition-all duration-300 p-8 h-full flex flex-col relative z-10">
                <div className="mb-4 text-blue-400">
                  <FaQuoteLeft className="text-3xl" />
                </div>
                <p className="text-gray-300 mb-6 flex-grow leading-relaxed italic">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-blue-500 border-opacity-20 pt-4">
                  <div className="font-semibold text-white">{testimonial.author}</div>
                  <div className="text-sm text-gray-400">{testimonial.role}</div>
                  <div className="text-sm text-blue-400">{testimonial.company}</div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>

        {/* Stats Banner */}
        <AnimatedSection delay={0.4}>
          <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-xl shadow-xl p-8 text-white text-center">
            <div className="text-4xl md:text-5xl font-bold mb-2">5+</div>
            <div className="text-xl md:text-2xl mb-4">Enterprise Users</div>
            <p className="text-blue-100 text-lg">
              More than 5 happy enterprise users rely on our tools to power their business success. Every day. Worldwide.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Testimonials;

